import { render, staticRenderFns } from "./QuestionnaireV2.vue?vue&type=template&id=10ee65c0&"
import script from "./QuestionnaireV2.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports